import { useEffect, useContext} from "react"
import { Link } from "react-router-dom";
import { MapaEntidades } from "../components/MapaEntidades";

export const HomePage = () => {
    

    return (
            <div className="h-full w-full">
                <MapaEntidades mode="public" className="h-full w-full" />
            </div>
    )
}

//bg-custom-cyan border-solid border-8 border-gray-300